import { AGGREGATION_MODES } from '@/modules/customerVbzWorksheet/components/DutyAggregationRules';

const debug = false;

export default {
  processDutyActivities(rules, dutyActivities) {
    let aggregatedDutyActivities = [];
    let aggregationMode = AGGREGATION_MODES.aggregate;
    let aggregatedDa;

    for (let i = 0; i < dutyActivities.length; i++) {
      let da = { ...dutyActivities[i] };
      let { fromMinutesAfterMidnight, toMinutesAfterMidnight } = da;
      // da.from = dateUtils.getTimeFromMinutesAfterMidnight(this.configuredTimeFormat, fromMinutesAfterMidnight);
      // da.to = dateUtils.getTimeFromMinutesAfterMidnight(this.configuredTimeFormat, toMinutesAfterMidnight);

      this.logDebugInfo(aggregatedDa, da);

      // Loop all vbzAggregationRules and use the aggregation mode of the first which applies
      let ruleResponse;
      for (let r = 0; r < rules.length; r++) {
        ruleResponse = rules[r](aggregatedDa, da);
        if (ruleResponse.isRuleMatch) break;
      }
      aggregationMode = ruleResponse.aggregationMode;
      let appliedRule = ruleResponse.appliedRule;
      if (debug) console.debug(`==> applied rule: ${appliedRule}`);
      switch (aggregationMode) {
        case AGGREGATION_MODES.createNew:
          if (aggregatedDa && da.activityShortname === 'Wege' && ['WOLP'].indexOf(aggregatedDa.toLocation) < 0) {
            if (debug) console.debug('Set toLocation of aggregatedDa to location of new activity');
            aggregatedDa.toLocation = da.fromLocation;
          }
          if (debug) console.debug('Split: create new activity');
          aggregatedDa = { ...da };
          aggregatedDutyActivities.push(aggregatedDa);
          break;

        case AGGREGATION_MODES.aggregate:
          if (debug) console.debug(`aggregation mode ${aggregationMode}`);
          aggregatedDa.toMinutesAfterMidnight = da.toMinutesAfterMidnight;
          aggregatedDa.activityShortname = da.activityShortname;
          aggregatedDa.activityLongname = da.activityLongname;
          aggregatedDa.shortName = da.shortName;
          aggregatedDa.toLocation = da.toLocation; //???
          if (da.blockcode) aggregatedDa.blockcode = da.blockcode;

          if (!aggregatedDa.from) aggregatedDa.from = da.from;
          aggregatedDa.to = da.to;

          aggregatedDa.endStopIdFk = da.endStopIdFk;
          if (da.line) {
            if (debug) console.debug(`Adapt line from ${aggregatedDa.line} to ${da.line}`);
            aggregatedDa.line = da.line;
          }
          if (da.course) {
            if (debug) console.debug(`Adapt course from ${aggregatedDa.course} to ${da.course}`);
            aggregatedDa.course = da.course;
          }
          break;

        case AGGREGATION_MODES.ignore:
          if (debug) console.debug('ignore');
          break;

        default:
          if (debug) console.debug('ignore if no aggregation mode defined');
      }
      aggregationMode = 'aggregate';
      if (debug) console.debug(' ');
    }
    return aggregatedDutyActivities;
  },
  logDebugInfo(aggregatedDa, da) {
    if (debug && aggregatedDa) {
      console.debug(
        'runningDa',
        JSON.stringify({
          blockcode: aggregatedDa.blockcode,
          line: aggregatedDa.line,
          course: aggregatedDa.course,
          from: aggregatedDa.from,
          fromMinutesAfterMidnight: da.fromMinutesAfterMidnight,
          fromLocation: aggregatedDa.fromLocation,
          to: aggregatedDa.to,

          toMinutesAfterMidnight: aggregatedDa.toMinutesAfterMidnight,

          toLocation: aggregatedDa.toLocation,
          activityShortname: aggregatedDa.activityShortname,
        })
      );
    }
    if (debug)
      console.debug(
        '       da',
        JSON.stringify({
          blockcode: da.blockcode,
          line: da.line,
          course: da.course,
          from: da.from,
          fromMinutesAfterMidnight: da.fromMinutesAfterMidnight,
          fromLocation: da.fromLocation,
          to: da.to,
          toLocation: da.toLocation,

          toMinutesAfterMidnight: da.toMinutesAfterMidnight,

          activityShortname: da.activityShortname,
        })
      );
  },
};
